import { components } from 'react-select'

import type { ReactElement } from 'react'
import type { OptionProps } from 'react-select'
import type { ISelectOption } from '~/types/option'

import './styles.scss'

const CustomImageOption = (props: OptionProps): ReactElement => {
  const { className, cx, data, innerProps, innerRef, isDisabled, isFocused, isSelected } = props

  const { image } = data as ISelectOption

  return (
    <div
      className={cx(
        {
          'custom-image': true,
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      {image ? <div className="custom-image-options">{image}</div> : null}
      <components.Option {...props} />
    </div>
  )
}

export default CustomImageOption
